import * as PIXI from 'pixi.js';
import type { TextLineMetrics } from './TextLineMetrics';
import { HighlightSpan } from './HighlightSpan';
import { WordElementSprite } from './WordElementSprite';

/**
 * `HighlightLine` is a container which holds one or more `HighlightSpan`, corresponding to a single line.
 *
 */
export class HighlightLine extends PIXI.Container {
    classType = 'HighlightLine';

    #lineMetrics: TextLineMetrics;

    constructor(metrics: TextLineMetrics) {
        super();
        this.#lineMetrics = metrics;
    }

    get metrics(): TextLineMetrics {
        return this.#lineMetrics;
    }

    get highlightSpans(): HighlightSpan[] {
        return this.children.filter(child => child instanceof HighlightSpan) as HighlightSpan[];
    }

    get hasVisibleText(): boolean {
        return this.#lineMetrics.getBounds().width > 0;
    }

    get wordElementSprites(): WordElementSprite[] {
        return this.highlightSpans
            .flatMap(span => span.children.filter(child => child instanceof WordElementSprite)) as WordElementSprite[];
    }

    _addInternalChild(child: PIXI.Container) {
        return super.addChild(child);
    }

    _addInternalChildAt(child: PIXI.Container, index: number) {
        return super.addChildAt(child, index);
    }

    _removeInternalChild(child: PIXI.Container) {
        return super.removeChild(child);
    }
}

